/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
let publicPath = ''
if (process.env.VUE_APP_MODE === 'test') {
    publicPath = 'https://www.gla.ac.uk/t4/uofglife/test/'
  } else if (process.env.VUE_APP_MODE === 'hybrid') {
    publicPath = ''
  } else if (process.env.VUE_APP_MODE === 'production') {
    publicPath = 'https://www.gla.ac.uk/t4/uofglife/production/'
  }
  
export const UofGMSALConfig = {
    auth: {
        // 'Application (client) ID' of app registration in Azure portal - this value is a GUID
        clientId: "c9efa4d2-a3f0-4098-ba85-0643d408bacd",
        // Full directory URL, in the form of https://login.microsoftonline.com/<tenant-id>
        authority: "https://login.microsoftonline.com/6e725c29-763a-4f50-81f2-2e254f0133c8",
        // Full redirect URL, in form of http://localhost:3000
        // redirectUri: "http://localhost:8081/",
        redirectUri: publicPath !== '' ? publicPath : window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const tokenRequest = {
    scopes: ["User.Read", "Mail.Read"],
    forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
};